module.exports = __webpack_public_path__ + "components/questionnaire-banner/static/icon-close-5ab74e3979a469489ab67c4f239d7e1a.svg";